import React, { Component } from 'react'
import { connect } from 'react-redux'

import ConfirmationModal from './ConfirmationModal'
import OptionsContainer from './OptionsContainer'
import TransferSummary from './TransferSummary'
import AboutOrder from './AboutOrder'
import OrderSummary from './OrderSummary'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import { clearErrorData, getInvoiceDiscountOptions, postOrder } from './ducks'
import { getOrder } from '../Confirmation/actions'
import clients from 'redux/clients'

import { Alert } from 'loyal-react'
import { SecondFactorAuthentication } from '../Checkout/SecondFactorAuthenticaton'
import { actions } from '../Checkout'

class InvoiceCredit extends Component {
  constructor (props) {
    super(props)
    this.state = {
      conversionValues: [],
      selectedDiscount: null,
      selectedID: null,
      showModal: false,
      alertSuccess: true,
      isCompletedOrder: false,
      calledAgain: false
    }
    this.handleSelectInvoice = this.handleSelectInvoice.bind(this)
    this.finishOrder = this.finishOrder.bind(this)
    const {
      cloudloyalty: { client }
    } = clients
    this.client = client
  }

  componentDidMount () {
    this.props.getInvoiceDiscountOptions()
    setTimeout(() => {
      const alert = document.getElementById('alert-message-box')

      if (alert) {
        alert.focus()
      }
    }, 700)
  }

  componentDidUpdate (prevProps) {
    if ((prevProps.invoiceCreditCardDiscountOrder !== this.props.invoiceCreditCardDiscountOrder)) {
      if (!this.props.orderConfirmed &&
        this.props.invoiceCreditCardDiscountOrder &&
        this.props.invoiceCreditCardDiscountOrder.id) {
        this.props.getOrder(this.props.invoiceCreditCardDiscountOrder.id)

        const utmURL = window.sessionStorage.getItem('utm-url')
        if (utmURL) {
          this.client
            .post(`v1/purchases/utm`, {
              ParentOrderId: this.props.invoiceCreditCardDiscountOrder.id,
              Url: utmURL
            })
        }
      }
    }

    if (this.props.errorData && this.props.errorData.code === 348 && !this.state.calledAgain) {
      this.props.getInvoiceDiscountOptions()
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        calledAgain: true,
        selectedDiscount: null,
        selectedID: null
      })
    }
  }
  handleSelectInvoice (id, obj) {
    const { balance } = this.props

    let isError = false

    if (Number(obj.points) > Number(balance.pointsValue)) {
      isError = true
    }
    const finalValue = obj.id === this.state.selectedID ? null : { ...obj, isError }
    const value = this.state.selectedID === id ? null : id

    this.setState({
      selectedDiscount: finalValue,
      selectedID: value
    })
  }

  finishOrder () {
    this.props.postOrder(this.state.selectedID)
    setTimeout(() => {
      const alert = document.getElementById('alert-message-box')

      if (alert) {
        alert.focus()
      }
    }, 1000)
  }

  setPropstoState (name, value) {
    this.setState({ [name]: value })
  }

  render () {
    return (
      <React.Fragment>
        <Helmet>
          <title>{`Crédito em fatura - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        {this.state.showModal && (
          <ConfirmationModal
            finishOrder={this.finishOrder}
            closeModal={() => this.setPropstoState('showModal', false)}
            selectedDiscount={this.state.selectedDiscount}
            pointsName={this.props.pointsName}
          />
        )}
        <div className='flex-wrap container-fluid align-items-start justify-content-center bg-ui-4 mt-sm-0 pb-5 d-flex flex-column flex-md-row'>
          <div className='container flex-wrap d-flex flex-column flex-md-row'>
            {
              this.props.invoiceCreditCardDiscountOrder &&
            this.props.invoiceCreditCardDiscountOrder.id &&
            this.props.authorized
                ? (
                  <React.Fragment>
                    {this.state.alertSuccess &&
                      <div className='container-fluid pt-3 px-0 mt-3'>
                        <Alert
                          title='Parabéns! Seu resgate será efetuado em até 48 horas.'
                          description='Acompanhe os detalhes do seu pedido.'
                          onClose={() => this.setPropstoState('alertSuccess', false)}
                          className='px-md-5 px-0 mt-5'
                          isSuccess
                        />
                      </div>
                    }
                    {this.props.orderConfirmed &&
                    <OrderSummary
                      parentOrderId={this.props.invoiceCreditCardDiscountOrder.id}
                      selectedDiscount={this.state.selectedDiscount}
                      pointsName={this.props.pointsName}
                      itemId={this.props.orderConfirmed.vendorOrderModel[0].items[0].id}
                      orderId={this.props.orderConfirmed.vendorOrderModel[0].orderId}
                    />
                    }
                    <AboutOrder
                      selectedDiscount={this.state.selectedDiscount}
                      pointsName={this.props.pointsName}
                    />
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {this.props.errorData && this.props.errorData.message &&
                    <div className='container-fluid px-md-5 px-0 mt-3'>
                      <Alert
                        id='invoice-transfer-alert'
                        title={this.props.errorData.message}
                        description={this.props.errorData.subMessage || ''}
                        className='px-md-5 px-0 mt-5'
                        onClose={() => this.props.clearErrorData()}
                        isError
                      />
                    </div>
                    }
                    <OptionsContainer
                      selectedDiscount={this.state.selectedDiscount}
                      conversionValues={this.props.options}
                      selectedID={this.state.selectedID}
                      handleSelectInvoice={this.handleSelectInvoice}
                      pointsName={this.props.pointsName}
                    />
                    <TransferSummary
                      selectedID={this.state.selectedID}
                      selectedDiscount={this.state.selectedDiscount}
                      openModal={() => this.setPropstoState('showModal', true)}
                      processing={this.props.processing}
                      pointsName={this.props.pointsName}
                    />
                  </React.Fragment>
                )
            }
            {
              this.props.secondFactorAuthentication &&
            this.props.secondFactorAuthentication.enable &&
            !this.props.authorized &&
            (
              <div className='modalConfirmationVoucher'>
                <SecondFactorAuthentication
                  {...this.props}
                  show={this.props.secondFactorAuthentication.enable}
                  secondFactorAuthConfirmated={this.props.secondFactorAuthentication.AuthenticationConfirmed}
                  confirmedOrderId={this.props.secondFactorAuthentication.confirmedOrderId}
                  oidc={this.props.oidc}
                  paymentSelected='POINTS_ONLY'
                  closeModal={this.props.closeModal}
                  authorizeWithTokenResend={this.props.authorizeWithTokenResend}
                  authorizeWithToken={this.props.authorizeWithToken}
                  authorizeWithTokenLastTry={this.props.authorizeWithTokenLastTry}
                  isCreatingPurchase={this.props.isCreatingPurchase}
                  errorToken={this.props.errorToken}
                  phone={this.props.secondFactorAuthentication.phone}
                />
              </div>
            )
            }
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ balance, invoiceCredit, oidc, checkout, catalog: { currencyConfiguration } }) => ({
  ...checkout,
  ...invoiceCredit,
  options: invoiceCredit.options || [],
  invoiceCreditCardDiscountOrder: invoiceCredit.invoiceCreditCardDiscountOrder,
  processing: invoiceCredit.processing,
  pointsName: currencyConfiguration.pointsName,
  errorData: invoiceCredit.errorData,
  oidc,
  orderConfirmed: invoiceCredit.orderConfirmed,
  balance
})

const mapDispatchToProps = dispatch => ({
  getInvoiceDiscountOptions: () => dispatch(getInvoiceDiscountOptions()),
  postOrder: (id) => dispatch(postOrder(id)),
  clearErrorData: () => dispatch(clearErrorData()),
  getOrder: OrderId => dispatch(getOrder(OrderId)),
  clearRedux: () => dispatch(actions.clearRedux()),
  authorizeWithToken: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend,
    lastTry = false
  ) =>
    dispatch(
      actions.authorizeWithToken(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend,
        lastTry
      )
    ),
  authorizeWithTokenResend: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      actions.authorizeWithTokenResend(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  authorizeWithTokenLastTry: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      actions.authorizeWithTokenLastTry(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    )
})

InvoiceCredit.propTypes = {
  getInvoiceDiscountOptions: PropTypes.func,
  postOrder: PropTypes.func,
  options: PropTypes.array,
  invoiceCreditCardDiscountOrder: PropTypes.object,
  processing: PropTypes.bool,
  balance: PropTypes.object,
  errorData: PropTypes.object,
  clearErrorData: PropTypes.func,
  secondFactorAuthentication: PropTypes.object,
  oidc: PropTypes.object,
  closeModal: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  authorizeWithToken: PropTypes.func,
  authorizeWithTokenLastTry: PropTypes.func,
  isCreatingPurchase: PropTypes.func,
  errorToken: PropTypes.func,
  clarRedux: PropTypes.func,
  authorized: PropTypes.bool,
  pointsName: PropTypes.string,
  getOrder: PropTypes.func,
  orderConfirmed: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceCredit)



// WEBPACK FOOTER //
// ./src/features/InvoiceCredit/index.js